const LIGHT_GREY = "#ced4da";

const WHITE_BASE_COLOR = "#ffff";

export { LIGHT_GREY, WHITE_BASE_COLOR };
